export enum Ga4Event {
    HPProductPlanned = 'hp_product_planned',
    PVProductPlanned = 'pv_product_planned',
    QuoteAdded = 'quote_added',
    HeatLoadCalculationStarted = 'hl_calculation_started',
    HeatLoadRecalculationStarted = 'hl_recalculation_started',
    HeatLoadCalculationCompleted = 'hl_calculation_completed'
}
